import React from 'react'
import { Register } from '../components/Register/Register'

export const RegisterPage = () => {
  return (
    <Register />
  )
}
